import * as React from 'react';
import {ProgramType} from 'api/course';
import Growplace from './components/Growpalce';

/**
 * The component render current content program
 * @constructor
 */
export default function ContentController(): React.ReactElement {
  switch (process.env.REACT_APP_COURSE_TYPE) {
    case ProgramType.Growplace: return <Growplace />;
    default: return <React.Fragment />;
  }
}
